import { SET_AUTH_DIALOG } from './actionTypes'

const setAuthDialog = (payload) => ({
  type: SET_AUTH_DIALOG,
  payload
})

export default setAuthDialog;
